var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"thumbnail",attrs:{"target":"_blank","href":_vm.image.source}},[_c('img',{attrs:{"src":_vm.image.thumbnail,"alt":_vm.image.alt}})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('h3',[_vm._v(_vm._s(_vm.image.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.image.caption))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c25253c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thumbnail/thumbnail.vue
// module id = null
// module chunks = 